import React, {useCallback} from 'react'
import {useDropzone} from 'react-dropzone'
import {CircularProgress} from "@material-ui/core";

export const SimpleDropZoneOneFile = (props) => {

    const {setAlert, uploadedFile, setUploadedFile, isUploading, setIsUploading, setFastPrintFileName} = props;

    const onDrop = useCallback(acceptedFiles => {
        if(acceptedFiles.length !== 1){
            setAlert({message: 'Merci de n\'envoyer qu\'un seul fichier.', status: "error", date: new Date()});
            return;
        }

        const file = acceptedFiles[0];
        setUploadedFile(file);
        setFastPrintFileName(file.name);
    }, []);

    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop});


    return (
        !isUploading ? (
            <div {...getRootProps()} className="dropzone dropzone-small">
                <input {...getInputProps({})} />
                {
                    isDragActive ?
                        <p>Relâcher pour envoyer...</p>
                    : uploadedFile !== null && uploadedFile.name !== undefined ?
                        <p>{uploadedFile.name}</p>
                    :
                        <p>Glisser et déposer ou ajouter les fichiers</p>
                }
            </div>
        ) : (
            <>
                <div className="progresszone">
                    <CircularProgress />
                    <p>Traitement en cours...</p>
                </div>
            </>
        )
    )
}